import React from 'react';
import { ResponsiveTable } from '../../../components/Layout';
import ClassicLoadingSpinner from '../../../components/LoadingSpinner/ClassicLoadingSpinner';
import { ITransaction, TransactionType } from '../types';
import i18n from '@/utils/i18n';
import { Routes } from '@/utils/routes';
import { Link } from 'react-router-dom';

interface UserTransactionTabsProps {
  transactionHistory: ITransaction[];
  transactionHistoryLoaded: boolean;
  transactionHistoryLoading: boolean;
  transactionType: TransactionType;
}

export const UserTransactionTabs: React.FC<UserTransactionTabsProps> = ({
  transactionHistory,
  transactionHistoryLoaded,
  transactionHistoryLoading,
  transactionType,
}) => {
  if (!transactionHistoryLoaded && !transactionHistoryLoading) {
    return <ClassicLoadingSpinner />;
  }

  if (transactionHistoryLoading) {
    return <ClassicLoadingSpinner />;
  }

  const relevantTransactions: ITransaction[] = transactionHistory
    .filter((_) => _.type === transactionType)
    .sort((a, b) =>
      b.transactionTime.localeCompare(a.transactionTime, i18n.language, {
        numeric: true,
      }),
    );

  return (
    <ResponsiveTable>
      <thead>
        <tr>
          <th>Container</th>
          <th>Transaction Partner Name</th>
          <th>Transaction Time</th>
        </tr>
      </thead>
      <tbody>
        {relevantTransactions.map((transaction) => (
          <tr key={transaction.locationId} style={{ cursor: 'pointer' }}>
            <td>
              <Link to={Routes.container(transaction.containerId)}>
                {transaction.containerName}
              </Link>
            </td>
            <td
              onClick={() => {
                const win = window.open(
                  '/container/' + transaction.containerId,
                );
                win && win.focus();
              }}
            >
              {transaction.transactionPartnerName}
            </td>
            <td
              onClick={() => {
                const win = window.open(
                  '/container/' + transaction.containerId,
                );
                win && win.focus();
              }}
            >
              {transaction.transactionTime.toDateString(true)}
            </td>
          </tr>
        ))}
      </tbody>
    </ResponsiveTable>
  );
};
